import { render, staticRenderFns } from "./PurchaseSmsCreditModal.vue?vue&type=template&id=ef01970c&scoped=true"
import script from "./PurchaseSmsCreditModal.vue?vue&type=script&lang=js"
export * from "./PurchaseSmsCreditModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSmsCreditModal.vue?vue&type=style&index=0&id=ef01970c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef01970c",
  null
  
)

export default component.exports